export enum EnumPartnerAndClientEmployees {
  "1-4" = "1-4",
  "5-9" = "5-9",
  "10-49" = "10-49",
  "50-99" = "50-99",
  "100-499" = "100-499",
  "500-1999" = "500-1999",
  "2000+" = "2000+",
}
